import { FC } from 'react';
import { Route, Switch } from 'react-router-dom';
import SystemCode from '../pages/system/code';
import SystemCodeCreate from '../pages/system/code/create';
import SystemCodeEdit from '../pages/system/code/edit';
import SystemCodeSubcode from '../pages/system/code/subcode';
import SystemCodeSubcodeCreate from '../pages/system/code/subcode/create';
import SystemCodeSubcodeEdit from '../pages/system/code/subcode/edit';
import SystemSchool from '../pages/system/school';
import SystemSchoolCreate from '../pages/system/school/create';
import SystemSchoolRead from '../pages/system/school/read';
import SystemSchoolEdit from '../pages/system/school/edit';
import SystemPublisher from '../pages/system/publisher';
import SystemPublisherCreate from '../pages/system/publisher/create';
import SystemPublisherEdit from '../pages/system/publisher/edit';
import SystemMenu from '../pages/system/menu';
import SystemMenuCreate from '../pages/system/menu/create';
import SystemMenuEdit from '../pages/system/menu/edit';
import SystemMenuSubmenu from '../pages/system/menu/submenu';
import SystemMenuSubmenuCreate from '../pages/system/menu/submenu/create';
import SystemMenuSubmenuEdit from '../pages/system/menu/submenu/edit';
import SystemGroup from '../pages/system/group';
import SystemGroupCreate from '../pages/system/group/create';
import SystemGroupEdit from '../pages/system/group/edit';
import SystemAuth from '../pages/system/auth';
import SystemLocale from '../pages/system/locale';
import SystemLocaleCreate from '../pages/system/locale/create';
import SystemLocaleEdit from '../pages/system/locale/edit';
import SystemTreeCode from '../pages/system/treecode';
import SystemTreeCodeCreate from '../pages/system/treecode/create';
import SystemTreeCodeEdit from '../pages/system/treecode/edit';
import SystemTreeCodeSubcode from '../pages/system/treecode/subcode';

const SystemRouter: FC = () => {
  return (
    <Switch>
      <Route path='/system/code' exact component={SystemCode} />
      <Route path='/system/code/create' exact component={SystemCodeCreate} />
      <Route path='/system/code/:id/edit' exact component={SystemCodeEdit} />
      <Route path='/system/code/:id/subcode' exact component={SystemCodeSubcode} />
      <Route path='/system/code/:id/subcode/create' exact component={SystemCodeSubcodeCreate} />
      <Route path='/system/code/:topId/subcode/:subId/edit' exact component={SystemCodeSubcodeEdit} />
      <Route path='/system/school' exact component={SystemSchool} />
      <Route path='/system/school/create' exact component={SystemSchoolCreate} />
      <Route path='/system/school/:id/read' exact component={SystemSchoolRead} />
      <Route path='/system/school/:id/edit' exact component={SystemSchoolEdit} />
      <Route path='/system/publisher' exact component={SystemPublisher} />
      <Route path='/system/publisher/create' exact component={SystemPublisherCreate} />
      <Route path='/system/publisher/:schoolCode/edit' exact component={SystemPublisherEdit} />
      <Route path='/system/menu' exact component={SystemMenu} />
      <Route path='/system/menu/create' exact component={SystemMenuCreate} />
      <Route path='/system/menu/:id/edit' exact component={SystemMenuEdit} />
      <Route path='/system/menu/:id/submenu' exact component={SystemMenuSubmenu} />
      <Route path='/system/menu/:id/submenu/create' exact component={SystemMenuSubmenuCreate} />
      <Route path='/system/menu/:topId/submenu/:subId/edit' exact component={SystemMenuSubmenuEdit} />
      <Route path='/system/group' exact component={SystemGroup} />
      <Route path='/system/group/create' exact component={SystemGroupCreate} />
      <Route path='/system/group/:id/edit' exact component={SystemGroupEdit} />
      <Route path='/system/auth' exact component={SystemAuth} />
      <Route path='/system/locale' exact component={SystemLocale} />
      <Route path='/system/locale/create' exact component={SystemLocaleCreate} />
      <Route path='/system/locale/:id/edit' exact component={SystemLocaleEdit} />
      <Route path='/system/treecode' exact component={SystemTreeCode} />
      <Route path='/system/treecode/create' exact component={SystemTreeCodeCreate} />
      <Route path='/system/treecode/:id/edit' exact component={SystemTreeCodeEdit} />
      <Route path='/system/treecode/:id/subcode' exact component={SystemTreeCodeSubcode} />
    </Switch>
  )
}

export default SystemRouter;
